import { types as t } from 'mobx-state-tree'
import { CirclesModel } from './CirclesModel'
import { CountriesModel } from './CountriesModel'
import { YearsModel } from './YearsModel'
import { ChallengesModel } from './ChallengesModel'

export const StateModel = t.model('StateModel', {
  Circles: t.optional(CirclesModel, {}),
  CountriesState: t.optional(CountriesModel, {}),
  YearsState: t.optional(YearsModel, {}),
  ChallengesState: t.optional(ChallengesModel, {}),
})

export type StateType = typeof StateModel.Type
export interface IStateable {
  state?: StateType
}
